/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { useServiceContext } from '../../../root'
import ActionsMenuBig from '../../../components/shared/ActionsMenuBig'

const PageMenu: React.FC<{ onAddTag: () => void }> = ({ onAddTag }) => {
  const context = useServiceContext()

  const settings = {
    menuId: 'page',
    items: [
      {
        value: 'SETTINGS_TAGS_ADD',
        action: onAddTag
      }
    ]
  }

  return <ActionsMenuBig {...settings} />
}

export default PageMenu
